// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 15 15" {...rest} unit={unit}>
		<g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g id="GameplayComponent/Key-Mobile" transform="translate(-20.000000, -264.000000)"
				fill="#C0C0C0" fillRule="nonzero">
				<g id="2" transform="translate(20.000000, 179.000000)">
					<g id="Cannot" transform="translate(0.000000, 85.000000)">
						<g id="UI/Icon/Grey/Stop">
							<path d="M7.5,0.9375 C11.1370482,0.9375 14.0625,3.86295181 14.0625,
							7.5 C14.0625,11.1370482 11.1370482,14.0625 7.5,14.0625 C3.86295181,
							14.0625 0.9375,11.1370482 0.9375,
							7.5 C0.9375,3.86295181 3.86295181,0.9375 7.5,0.9375 Z M4.41176471,
							3.49494485 L11.5050551,10.5882353 C12.1286411,
							9.7697787 12.5183824,8.71747738 12.5183824
							,7.54825368 C12.5183824,4.78109092 10.2578832,
							2.48161765 7.45174632,2.48161765 C6.32149675
							,2.48161765 5.26919542,2.87135888 4.41176471,3.49494485 Z M10.5882353,
							11.5050551 L3.49494485,4.41176471 C2.87135888,5.26919542 2.48161765
							,6.32149675 2.48161765,7.45174632 C2.48161765,10.2578832 4.78109092,
							12.5183824 7.54825368,12.5183824 C8.71747738,12.5183824 9.7697787,
							12.1286411 10.5882353,11.5050551 Z" id="Shape" />
						</g>
					</g>
				</g>
			</g>
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Inactive.js